<template>
    <div>
        <limitless-page-header v-if="!include" :loading="busy_loading" :title="'Kontakt'" :sub-title="contact_name" :title-id="contact_id"></limitless-page-header>

        <div :class="{ 'content': !include }">
            <div v-if="busy_loading" :class="{ 'text-center': include }">
                <i class="icon-spinner2 spinner"></i>
            </div>

            <div v-else-if="!busy_loading && contact">
                <div :class="{ 'card': !include }">
                    <div :class="{ 'card-body': !include }">
                        <ValidationObserver ref="contactform">
                            <form @submit.prevent="saveContact">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <input-with-validation
                                            vid="FullName"
                                            label="Namn"
                                            rules="required"
                                            v-model="contact.FullName"
                                        />
                                        <input-with-validation
                                            vid="Email"
                                            label="E-postadress"
                                            rules="email"
                                            v-model="contact.Email"
                                        />
                                        <input-with-validation
                                            vid="PhoneLandline"
                                            label="Telefon"
                                            v-model="contact.PhoneLandline"
                                        />
                                        <input-with-validation
                                            vid="PhoneMobile"
                                            label="Mobil"
                                            v-model="contact.PhoneMobile"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <ValidationProvider vid="isMain" name="Huvudkontakt / Reklamkontakt" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox mb-2">
                                                    <input type="checkbox" class="custom-control-input" id="chk-ismain" v-model="contact.isMain" :true-value="1" :false-value="0">
                                                    <label class="custom-control-label" for="chk-ismain">Huvudkontakt / Reklamkontakt</label>
                                                </div>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <select-with-validation
                                            vid="PostalAdrID"
                                            label="Postadress"
                                            :options="select_postal_addresses"
                                            :placeholder="'Välj postaddress'"
                                            v-model="contact.PostalAdrID"
                                            :reduce="(adr) => adr.DelivAdrID"
                                        />
                                        <select-with-validation
                                            vid="DefaultDelivAdrID"
                                            label="Standard leveransadress"
                                            :options="select_delivery_addresses"
                                            :placeholder="'Välj leveransaddress'"
                                            v-model="contact.DefaultDelivAdrID"
                                            :reduce="(adr) => adr.DelivAdrID"
                                        />
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                    <div :class="{ 'card-footer': !include }">
                        <div class="d-flex justify-content-end">
                            <limitless-button v-if="contact.ContactID > 0" ref="btndeletecontact" type="button" @click="deleteContact" :busy="busy_saving" icon="icon-cross2" btn-class="btn-danger" class="mr-auto">RADERA</limitless-button>
                            <limitless-button ref="btnsavecontact" type="button" @click="saveContact" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <i>Kontakten kunde ej hämtas...</i>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import Vue from 'vue';
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';

export default {
    name: 'CustomerContactEdit',
    components: {
        SelectWithValidation,
        InputWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
        // customerId: {
        //     type: [Number, String],
        //     required: true,
        // },
        customer: {
            type: Object,
            required: true,
        },
        include: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        contact: null,
    }),
    mounted() {
        this.getContact();
    },
    methods: {
        getContact() {
            this.busy_loading = true;
            apiClient.get('/vue/customercontacts/' + (this.contact && this.contact.ContactID > 0 ? this.contact.ContactID : this.id) + '')
                .then((response) => {
                    this.contact = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveContact() {
            const isValid = await this.$refs.contactform.validate();
            if (isValid) {
                this.busy_saving = true;
                this.contact.CustomerID = this.customer.CustomerID;
                await apiClient.post('/vue/customercontacts/' + (this.contact && this.contact.ContactID > 0 ? this.contact.ContactID : this.id), this.contact)
                    .then((response) => {
                        if (this.include) {
                            this.$emit('saved', response.data);
                        } else if (this.id !== response.data.id) {
                            window.location.href = '/contacts/' + response.data.ContactID;
                        }
                        this.contact = response.data;
                        this.$refs.btnsavecontact.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.contactform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecontact.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        deleteContact() {
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Are you sure you want to delete this contact?')) {
                this.busy_saving = true;
                apiClient.delete('/vue/customercontacts/' + (this.contact && this.contact.ContactID > 0 ? this.contact.ContactID : this.id))
                    .then(() => {
                        if (this.include) {
                            this.$emit('deleted');
                        } else {
                            document.location.href = '/contacts';
                        }
                        Vue.set(this, 'busy_saving', false);
                    })
                    .catch(() => {
                        this.$refs.btndeletecontact.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
    computed: {
        contact_name() {
            return (this.contact && this.contact.id > 0 ? this.contact.title : 'New contact');
        },
        contact_id() {
            return (this.contact && this.contact.id > 0 ? this.contact.id : '');
        },
        select_delivery_addresses() {
            const arr = [];
            if (this.customer && this.customer.delivery_addresses) {
                Object.values(this.customer.delivery_addresses).forEach((address) => {
                    const textarr = [];
                    if (address.DeliveryCompany) {
                        textarr.push(address.DeliveryCompany);
                    }
                    if (address.DeliveryAddress1) {
                        textarr.push(address.DeliveryAddress1);
                    }
                    if (address.DeliveryAddress2) {
                        textarr.push(address.DeliveryAddress2);
                    }
                    if (address.DeliveryCity) {
                        textarr.push(address.DeliveryCity);
                    }
                    if (address.DeliveryCountryCode) {
                        textarr.push(address.DeliveryCountryCode);
                    }
                    if (address.DeliveryContactName) {
                        textarr.push(address.DeliveryContactName);
                    }
                    arr.push({ id: address.DelivAdrID, label: textarr.join(', '), ...address });
                });
            }
            return arr;
        },
        select_postal_addresses() {
            const arr = [];
            if (this.customer && this.customer.postal_addresses) {
                Object.values(this.customer.postal_addresses).forEach((address) => {
                    const textarr = [];
                    if (address.DeliveryCompany) {
                        textarr.push(address.DeliveryCompany);
                    }
                    if (address.DeliveryAddress1) {
                        textarr.push(address.DeliveryAddress1);
                    }
                    if (address.DeliveryAddress2) {
                        textarr.push(address.DeliveryAddress2);
                    }
                    if (address.DeliveryCity) {
                        textarr.push(address.DeliveryCity);
                    }
                    if (address.DeliveryCountryCode) {
                        textarr.push(address.DeliveryCountryCode);
                    }
                    if (address.DeliveryContactName) {
                        textarr.push(address.DeliveryContactName);
                    }
                    arr.push({ id: address.DelivAdrID, label: textarr.join(', '), ...address });
                });
            }
            return arr;
        },
    },
};

</script>
